import { CURATOR_OWNER_NONCOMMERCIAL } from 'app/shared/utils/events';

interface EventForCalcFinalPrice {
  price: number;
  eventOrganizedAs: string;
  competition?: {
    id?: number;
  };
}

interface EventAttendeeForCalcFinalPrice {
  skipPayment?: boolean;
  source?: string;
}

interface CalculateFinalPriceProps {
  event: EventForCalcFinalPrice | null;
  eventAttendee: EventAttendeeForCalcFinalPrice | null;
  numberOfTickets: number;
  numberOfFreeTickets: number;
  fee: number;
  promoCodeIsValid?: boolean;
  promoCodeDiscountAmount: number;
  visaDiscountAmount: number;
}

/** Calculates the final price charged to the user at Checkout */
export function calculateFinalPrice({
  event,
  eventAttendee,
  numberOfTickets,
  numberOfFreeTickets,
  fee,
  promoCodeIsValid = false,
  promoCodeDiscountAmount,
  visaDiscountAmount,
}: CalculateFinalPriceProps) {
  if (!event) {
    return 0;
  }
  const eventPrice =
    eventAttendee?.skipPayment && !event.price ? 0 : event.price;
  const shouldSkipPayment =
    event.eventOrganizedAs === CURATOR_OWNER_NONCOMMERCIAL ||
    eventAttendee?.skipPayment === true;
  const attendeeIsCompetitionWinner =
    eventAttendee && eventAttendee.source === 'competition';
  const isCompetition = event?.competition?.id;

  if (shouldSkipPayment || (attendeeIsCompetitionWinner && isCompetition)) {
    return 0;
  }

  const ticketsTotalAmount = eventPrice * numberOfTickets;
  const feesTotalAmount =
    numberOfTickets > numberOfFreeTickets
      ? fee * (numberOfTickets - numberOfFreeTickets)
      : 0;
  const standardPrice = ticketsTotalAmount + feesTotalAmount;

  if (promoCodeIsValid) {
    return standardPrice - Number(promoCodeDiscountAmount);
  } else if (visaDiscountAmount) {
    return standardPrice - Number(visaDiscountAmount);
  }

  return standardPrice;
}
